import { Logo } from "@components/Logo"
import { Toasts } from "@components/Toasts"
import { Text } from "@components/ui/typograhpy/Text"
import { cn } from "@lib/cn"
import { NextSeo, NextSeoProps } from "next-seo"
import Image from "next/image"
import Link from "next/link"
import React, { ReactNode } from "react"

type SplitScreenPageProps = Omit<NextSeoProps, "children"> & {
  footerText?: any
  variant?: "default" | "error"
  children: ReactNode
  contentWrapperClassName?: string
}

export const SplitScreenPage = ({
  children,
  footerText,
  variant = "default",
  contentWrapperClassName,
  ...rest
}: SplitScreenPageProps) => {
  return (
    <>
      <NextSeo {...rest} />
      <Link
        href="/"
        passHref
        className={cn(
          "absolute ml-6 mt-4 overflow-hidden",
          "focus-visible:rounded-[3px] focus-visible:shadow-focus-visible focus-visible:outline-0",
        )}
      >
        <Logo variant="full" />
      </Link>
      <div
        className={cn(
          "grid h-screen grid-cols-[1fr] p-6",
          "md:grid-cols-[2fr_1fr] md:gap-x-4 lg:grid-cols-[1fr_1fr]",
          variant === "error" && "grid-rows-[22rem_1fr] md:grid-rows-[unset]",
        )}
      >
        <div
          className={cn(
            "flex h-auto w-full max-w-[364px] items-center justify-self-center",
            contentWrapperClassName,
          )}
        >
          {children}
          <Text
            variant="micro"
            className="absolute bottom-0 mb-6 max-w-[364px] text-center text-shade-500 md:text-left"
          >
            {footerText}
          </Text>
        </div>
        <div
          className={cn(
            "relative hidden md:block",
            variant === "error" && "block",
          )}
          data-variant={variant}
        >
          <Image
            src={getImageSrc(variant)}
            alt="example picture with before and after"
            layout="fill"
            objectFit="cover"
            className="rounded-md"
            priority
          />
        </div>
      </div>
      <Toasts />
    </>
  )
}

function getImageSrc(variant: SplitScreenPageProps["variant"]) {
  if (variant === "default") {
    return "/assets/auth-page-picture.jpg"
  }
  if (variant === "error") {
    return "/assets/error-splitpage.jpg"
  }
  return ""
}
